import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  hasError: false,
  errorMessage: null,
  data: null,
  window: 24, // horas
};

const slice = createSlice({
  name: "printMetrics",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.hasError = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.hasError = true;
      state.errorMessage = action.payload;
    },
    fetchSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    setWindow(state, action) {
      state.window = action.payload;
    },
  },
});

export default slice.reducer;
export const { setWindow } = slice.actions;

export function fetchPrintMetrics(hours = 24) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/health/print-metrics?hours=${hours}`);
      dispatch(slice.actions.fetchSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Error cargando métricas"));
    }
  };
}
